import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=d10c5f2e&"
import script from "./Creator.vue?vue&type=script&lang=js&"
export * from "./Creator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection,QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection,QInput,QIcon})
